import { Theme } from '@mui/material'

const classes = {
  paper: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceVariant,
    borderTopLeftRadius: theme.spacing(4),
    borderTopRightRadius: theme.spacing(4),
    width: '100%',
    maxHeight: '90vh',
    overflow: 'hidden',
  }),
  handleButton: {
    width: '100%',
    justifyContent: 'center',
    paddingTop: 2,
    paddingBottom: 1,
  },
  handle: (theme: Theme) => ({
    width: 36,
    height: 4,
    borderRadius: 2,
    backgroundColor: theme.palette.ui.outlineVariant,
  }),
  content: {
    flexDirection: 'column' as const,
    alignItems: 'center',
    flex: 1,
    minHeight: 0,
    overflowY: 'auto' as const,
    paddingX: 2,
    paddingTop: 2,
    rowGap: 2,
    textAlign: 'center' as const,
  },
  dialogBody: {
    flexDirection: 'column' as const,
    alignItems: 'center',
    rowGap: 2,
    textAlign: 'center' as const,
  },
  title: {
    fontWeight: 600,
  },
  image: {
    width: '100%',
    maxWidth: 390,
    display: 'block',
  },
  dialogActions: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  actions: (theme: Theme) => ({
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingX: 3,
    paddingY: 2,
  }),
}

export default classes
